import ReactOnRails from 'react-on-rails/client';
import OfficersAndBoard from '../../app/OfficersAndBoard.jsx';

ReactOnRails.register({OfficersAndBoard});